export const de = {
  license: {
    title: 'Enterprise-Lizenz',
    infoLabel: 'Hinweis zur Lizenz',
    info: 'Die Werte werden nur geschrieben und nie wieder angezeigt, leere Felder lassen den gespeicherten Wert unverändert.',
    save: 'Lizenz speichern',
    saved: 'Lizenz gespeichert.',
    saveFailed: 'Lizenz konnte nicht gespeichert werden.',
    isSet: 'Gesetzt',
    wizardHint: 'Optional, die Lizenz lässt sich auch später am Mandanten hinterlegen.',
    wizardFailedPrefix: 'Mandant angelegt, Lizenz nicht gespeichert:',
    keys: {
      license: 'Nubus-Lizenz',
      'openproject-token': 'OpenProject-Token',
      'xwiki-license': 'XWiki-Lizenz',
      'xwiki-pro-applications-license': 'XWiki-Pro-Applications-Lizenz',
      'nextcloud-subscription-key': 'Nextcloud-Subscription-Key',
      'nextcloud-subscription-data': 'Nextcloud-Subscription-Daten (optional)',
    },
  },
  controlPlaneLoss: {
    title: 'Login dieser Oberfläche betroffen',
    bodyPrefix: 'Der Mandant',
    bodySuffix: 'hostet den Login dieser Oberfläche, nach dem Löschen kann sich niemand mehr anmelden.',
    phrase: 'AUSSPERREN',
    confirm: 'Trotzdem löschen',
  },
};

export const en = {
  license: {
    title: 'Enterprise licence',
    infoLabel: 'About the licence',
    info: 'Values are write-only and never shown again, and empty fields keep the stored value.',
    save: 'Save licence',
    saved: 'Licence saved.',
    saveFailed: 'Could not save the licence.',
    isSet: 'Already set',
    wizardHint: 'Optional, you can also add the licence later on the tenant.',
    wizardFailedPrefix: 'Tenant created, licence not saved:',
    keys: {
      license: 'Nubus licence',
      'openproject-token': 'OpenProject token',
      'xwiki-license': 'XWiki licence',
      'xwiki-pro-applications-license': 'XWiki Pro Applications licence',
      'nextcloud-subscription-key': 'Nextcloud subscription key',
      'nextcloud-subscription-data': 'Nextcloud subscription data (optional)',
    },
  },
  controlPlaneLoss: {
    title: 'Login of this UI affected',
    bodyPrefix: 'Tenant',
    bodySuffix: 'hosts the login of this UI, so deleting it locks everyone out.',
    phrase: 'LOCK OUT',
    confirm: 'Delete anyway',
  },
};
